import constants from 'constants/index'

const {
  STEP_VISUAL_IDENTITY,
  STEP_SITE,
  STEP_COOKIE,
  STEP_DPO_APPOINTMENT,
  STEP_DOCS,
  STEP_CONCLUSION,
  VISUAL_IDENTITY_TAG,
  COMPANY_SITE_TAG,
  COOKIE_BANNER_TAG,
  DPO_APPOINTMENT_TAG,
  COMPANY_DOCUMENTS_TAG,
  CONCLUSION_TAG,
} = constants.userTrailSteps

const tagByIndex = (index) => {
  switch (index) {
    case STEP_VISUAL_IDENTITY:
      return VISUAL_IDENTITY_TAG
    case STEP_SITE:
      return COMPANY_SITE_TAG
    case STEP_COOKIE:
      return COOKIE_BANNER_TAG
    case STEP_DPO_APPOINTMENT:
      return DPO_APPOINTMENT_TAG
    case STEP_DOCS:
      return COMPANY_DOCUMENTS_TAG
    case STEP_CONCLUSION:
      return CONCLUSION_TAG
    default:
      return VISUAL_IDENTITY_TAG
  }
}

export default tagByIndex
